import React, { useContext } from 'react';
import { StudioButton } from 'venn-ui-kit';
import { useTheme } from 'styled-components';
import { UserContext } from 'venn-components';
import { MAX_INPUTS_PER_KIND } from 'venn-utils';

interface NewButtonProps {
  title: string;
  onAddNew: () => void;
  numberOfInputs: number;
}

interface ActionButtonProps {
  label: string;
  onClick: () => void;
  destructive: boolean | undefined;
}

const Root = ({ children }: React.PropsWithChildren) => (
  <div className="flex justify-between items-center bg-venn-grey-10 py-[8px] px-[12px]">{children}</div>
);

const NewButton = ({ title, onAddNew, numberOfInputs }: NewButtonProps) => {
  const { hasPermission } = useContext(UserContext);
  const readonly = !hasPermission('STUDIO_EDIT');
  const canAdd = !readonly && numberOfInputs < MAX_INPUTS_PER_KIND;
  const { Colors } = useTheme();

  return canAdd ? (
    <StudioButton data-testid={`new-${title}`} size="medium" onClick={onAddNew} color={Colors.DarkBlue}>
      New
    </StudioButton>
  ) : null;
};

const ActionButton = ({ label, onClick, destructive }: ActionButtonProps) => {
  const { hasPermission } = useContext(UserContext);
  const readonly = !hasPermission('STUDIO_EDIT');
  const { Colors } = useTheme();

  return (
    <StudioButton
      size="medium"
      onClick={onClick}
      color={destructive ? Colors.Error : Colors.DarkBlue}
      disabled={readonly}
    >
      {label}
    </StudioButton>
  );
};

const Text = ({ children }: React.PropsWithChildren) => (
  <div className="uppercase text-venn-grey-80 flex-1 font-bold">{children}</div>
);

export const PanelHeader = {
  Root,
  Text,
  NewButton,
  ActionButton,
};
